let today = new Date()
let index = 0;

//console.log(today)

document.addEventListener('DOMContentLoaded', () => {
    const
    toggles = document.querySelectorAll('[data-toggle]'),
    contents = document.querySelectorAll('[data-content]')
    
    toggles.forEach((ele, i) => {
      ele.addEventListener('click', (e) => {
        if(ele.querySelector('.store__link').contains(e.target)) return
        ele.classList.toggle('product__tab--active');
        toggleTab(contents[i])
      })
    });
    
    function toggleTab(tabContent) {
      tabContent.toggleAttribute('aria-hidden');
      if (tabContent.style.maxHeight) {
        tabContent.style.maxHeight = null;
      } else {
        tabContent.style.maxHeight = `${tabContent.scrollHeight}px` 
      }
    }
    

    if(window.theme.credentials.calendarApiKey && window.theme.credentials.calendarId) {
        if(window.gapi) {
            buildCalendar(previousMonday(today),nextSunday(today))
            //console.log(setDay(today, 1, true))
        } else {
            window.addEventListener('googleAPI:loaded', () => {
                buildCalendar(previousMonday(today),nextSunday(today))
                //console.log(setDay(today, 1, true))
            });
        }
    }

    const nextWeekBtn = document.querySelector('[data-next-week]')
    const prevWeekBtn = document.querySelector('[data-prev-week]')

    nextWeekBtn.addEventListener('click', () => {
        index ++;
        getWeek()
    })

    prevWeekBtn.addEventListener('click', () => {
        index --;
        getWeek()
    })

})



function getWeek() {
    const nextWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (index * 7))
    //console.log(nextWeek)
    buildCalendar(previousMonday(nextWeek),nextSunday(nextWeek))
}

async function buildCalendar(timeMin, timeMax) {
    //console.log(timeMin)
    const googleCalender = await getGoogleData(timeMin, timeMax)
    const stores = window.googleDataStores

    stores.forEach((store) => {
        const eventArray = googleCalender.filter(x => x.summary.toLowerCase().includes(store))
        
        let startOfWeek = previousMonday(today);
        let weekLog = []
        
        for (let i = 0; i < 7; i++) {
            const newday = startOfWeek.getDay();
            const test = eventArray.filter((x) => {
                const googleDay = new Date(x.start.dateTime).getDay();
                return googleDay == newday
            })

            if (test.length > 0) {
                const eventStart = getHourMinutes(new Date(test[0].start.dateTime));
                const eventEnd = getHourMinutes(new Date(test[0].end.dateTime));
                const eventItem = {
                    store: store,
                    start: startOfWeek.getDay(),
                    open_hours: `${eventStart} - ${eventEnd}`
                }
                weekLog.push(eventItem)
            } else {
                const eventItem = {
                    store: store,
                    start: startOfWeek.getDay(),
                    open_hours: window.languages.storeClosed
                }
                weekLog.push(eventItem)
            }

            startOfWeek.setDate(startOfWeek.getDate()+1);
        }

        const calendarTodayElement = document.querySelector(`[data-date-today="${store}"]`)

        const currentWeek = document.querySelector('[data-current-week]')
        currentWeek.innerHTML = `${timeMin.getDate()}/${timeMin.getMonth()+1} - ${timeMax.getDate()}/${timeMax.getMonth()+1}`

        const calendarTimeElements = document.querySelectorAll(`[data-calendar-time="${store}"]`)
        
        const todayTime = weekLog.filter(x=>today.getDay() == x.start)
        calendarTodayElement.innerHTML = todayTime[0].open_hours

        calendarTimeElements.forEach((ele, index) => {
            ele.innerHTML = weekLog[index].open_hours
        })
    })
    //console.log(googleCalender)
}

function previousMonday(date) {
    date = new Date(date.getTime ());
    if(date.getDay() != 1) {
        date.setDate(date.getDate() - (date.getDay() + 6) % 7);
    }
    date.setHours(0,0,0,999)
    return date;
}

function nextSunday(date) {
    date = new Date(date.getTime ());
    if(date.getDay() != 0) {
        date.setDate(date.getDate() + (0 - 1 - date.getDay() + 7) % 7 + 1);
    }
    date.setHours(23,59,59,999)
    return date;
}

const getGoogleData = (timeMin, timeMax) => { 
    return new Promise((resolve) => {
        window.gapi.load('client', () => {
            window.gapi.client.init({
                apiKey: window.theme.credentials.calendarApiKey,
                discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
            }).then(()=> window.gapi.client.calendar.events.list({
                calendarId: window.theme.credentials.calendarId,
                singleEvents: true,
                orderBy: 'startTime',
                timeMin: timeMin.toISOString(),
                timeMax: timeMax.toISOString(),
            })).then((r) => {
                resolve(r.result.items)
            })
        })
    })
}


// const getOpeningHours = async (test) => { 
//     console.log(test)
//     const nextWeekBtn = document.querySelector('[data-next-week]')
//     const prevWeekBtn = document.querySelector('[data-prev-week]')
//     const currentWeekBtn = document.querySelector('[data-current-week]')

//     const stores = window.googleDataStores
//     let today = new Date()

//     nextWeekBtn.addEventListener('click', () => {
//         increaseWeek()
//     })

//     prevWeekBtn.addEventListener('click', () => {
//         decreaseWeek()
//     })


//     // function increaseWeek() {
//     //     today.getDate() + 7
//     //     const googleCalendarData = await getGoogleData(setDay(today, 1, true),setDay(today, 0, false))
//     //     buildCalendar(googleCalendarData)
//     // }

//     function decreaseWeek() {

//     }

//     function setDay(date, dayOfWeek, time) {
//         date = new Date(date.getTime ());
//         date.setDate(date.getDate() + (dayOfWeek + 7 - date.getDay()) % 7);
//         (time) ? date.setHours(0,0,0,999) : date.setHours(23,59,59,999)
//         return date;
//     }

    

//     const getGoogleData = (timeMin, timeMax) => new Promise((resolve) => {
//         window.gapi.load('client', () => {
//             window.gapi.client.init({
//                 apiKey: window.theme.credentials.calendarApiKey,
//                 discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
//             }).then(()=> window.gapi.client.calendar.events.list({
//                 calendarId: window.theme.credentials.calendarId,
//                 singleEvents: true,
//                 orderBy: 'startTime',
//                 timeMin: timeMin.toISOString(),
//                 timeMax: timeMax.toISOString(),
//             })).then((r) => {
//                 resolve(r.result.items)
//             })
//         })
//     })

//     const googleCalendarData = await getGoogleData(setDay(today, 1, true),setDay(today, 0, false))
//     buildCalendar(googleCalendarData)
    
//     function buildCalendar(calendar) {
//         stores.forEach((store) => {
//             const eventArray = calendar.filter(x => x.summary.toLowerCase().includes(store))
            
//             let startOfWeek = setDay(today, 1, true);
//             let weekLog = []
            
//             for (let i = 0; i < 7; i++) {
//                 const newday = startOfWeek.getDay();
//                 const test = eventArray.filter((x) => {
//                     const googleDay = new Date(x.start.dateTime).getDay();
//                     return googleDay == newday
//                 })
    
//                 if (test.length > 0) {
//                     const eventStart = getHourMinutes(new Date(test[0].start.dateTime));
//                     const eventEnd = getHourMinutes(new Date(test[0].end.dateTime));
//                     const eventItem = {
//                         store: store,
//                         start: startOfWeek.getDay(),
//                         open_hours: `${eventStart} - ${eventEnd}`
//                     }
//                     weekLog.push(eventItem)
//                 } else {
//                     const eventItem = {
//                         store: store,
//                         start: startOfWeek.getDay(),
//                         open_hours: window.languages.storeClosed
//                     }
//                     weekLog.push(eventItem)
//                 }
    
//                 startOfWeek.setDate(startOfWeek.getDate()+1);
//             }
    
//             const calendarTodayElement = document.querySelector(`[data-date-today="${store}"]`)
    
//             const calendarTimeElements = document.querySelectorAll(`[data-calendar-time="${store}"]`)
            
//             const todayTime = weekLog.filter(x=>today.getDay() == x.start)
//             calendarTodayElement.innerHTML = todayTime[0].open_hours
    
//             calendarTimeElements.forEach((ele, index) => {
//                 ele.innerHTML = weekLog[index].open_hours
//             })
    
//         })
//     }


// }